module.exports = __webpack_public_path__ + "assets-cabinet/img/support-icon.5f5c8069.svg";